import { vuexEventPathGenerator } from '@/utils';
export const mutationType = {
    SET_ORDER_LIST: 'SET_ORDER_LIST',
    SET_WORKER: 'SET_WORKER',
    SET_ON_CLOSE_ACTION: 'SET_ON_CLOSE_ACTION',
};
export const vuexStoreMutationType = vuexEventPathGenerator(mutationType, 'allocationController');
const mutations = {
    [mutationType.SET_ON_CLOSE_ACTION](state, payload) {
        state.onCloseAction = payload;
    },
    [mutationType.SET_WORKER](state, payload) {
        state.selectedWorker = payload;
    },
    [mutationType.SET_ORDER_LIST](state, payload) {
        state.selectedOrderItemsObj = payload;
    },
};
export default mutations;
